<div class="modal fade" bsModal #modalRef="bs-modal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-right-full" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="comments-wrapper" [perfectScrollbar]>
          <div class="header-row">
            <h1>Comments ({{ this.countAllComments }})</h1>
            <img (click)="closeModal()" src="assets/img/x.svg" class="icon" alt="" />
          </div>

          <div class="filter-row">
            <label class="switch switch-pill switch-success">
              <input [(ngModel)]="showOnlyReviewersComments" class="switch-input" type="checkbox" />
              <span class="switch-slider"></span>
            </label>
            <div class="filter-label">Show only reviewer's comments</div>
          </div>

          <div *ngFor="let section of filteredComments">
            <div *ngFor="let comment of section.comments" class="section-wrapper" [attr.section]="section.label">
              <span class="section-label">{{ section.label }}</span>
              <div class="comment-card" [attr.question]="comment.question">
                <div class="comment-content">
                  <div class="question-row">
                    <img src="assets/img/svg/chat-fill.svg" class="chat" alt="" />
                    <div class="item-fill question-text">
                      <span class="question">{{ comment.question }}</span>
                      <img
                        src="assets/img/svg/chevron-right.svg"
                        class="chat chevron"
                        (click)="navigateToQuestion(comment); $event.stopPropagation()"
                        alt="" />
                    </div>
                  </div>
                  <div class="comment-body">
                    <span class="comment-text">{{ comment.text }}</span>
                    <span class="comment-meta">
                      Comment added: {{ dateAsString(comment.date) }} / {{ comment.username }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
